import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { dynamicStyles } from 'utils/resuable-css';
import { deviceBreakpoints, variables } from 'variables';

export const AppDrawerSC = styled.div`
  display: flex;
  height: 100vh;
  min-width: ${(props) => props.theme.default?.desktop_menu_width};
  max-width: ${(props) => props.theme.default?.desktop_menu_width};
  ${(props) =>
    dynamicStyles(props.theme.resolutions, 'desktop_menu_width', 'min-width', 'desktop_menu_width', 'max-width')};

  transition: left 500ms ease;

  @media only screen and (max-width: ${deviceBreakpoints.mLaptop}px) {
    position: fixed;
    top: ${(props) => props.theme.default?.top_bar_height};
    left: -${(props) => (props.isAppDrawerOpen ? 0 : props.theme.default?.desktop_menu_width)};
    height: calc(100vh - ${(props) => props.theme.default?.top_bar_height});
    z-index: 100000;
  }
`;

export const AppDrawerContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  width: 100%;
  height: 100%;

  @media only screen and (max-width: ${deviceBreakpoints.mLaptop}px) {
    display: none;
  }
`;

export const AppDrawerHeader = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${(props) => props.theme.default?.top_bar_height};
  height: ${(props) => props.theme.default?.top_bar_height};
  ${(props) => dynamicStyles(props.theme.resolutions, 'top_bar_height', 'height', 'top_bar_height', 'min-height')};
  background: ${(props) => props.theme.gray.shadeE};
`;

export const LogoImageSC = styled.img`
  width: ${(props) => props.theme.default?.logo_top_left};
  ${(props) => dynamicStyles(props.theme.resolutions, 'logo_top_left', 'width')};
`;

export const AppDrawerBody = styled.div`
  display: grid;
  grid-template-columns: ${variables.appDrawer.sectionLinksWidth}px 1fr;
  width: 100%;
  background: ${(props) => props.theme.secondaryColor};
`;

export const SectionLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.secondaryDarkColor};
  width: ${(props) => props.theme.default?.desktop_menu_icon_area_width};
  ${(props) => dynamicStyles(props.theme.resolutions, 'desktop_menu_icon_area_width', 'width')};
`;

export const SectionLink = styled(Link)`
  display: grid;
  align-items: center;
  justify-items: center;
  align-content: center;
  gap: 4px;
  height: 100px;
  color: ${(props) => props.theme.gray.shadeF};
  text-decoration: none;
  cursor: pointer;
  :hover {
    color: ${(props) => props.theme.gray.shadeF};
    .box-icon.iserver {
      background-position: top 40px left 0px;
    }
    .box-icon.ibare {
      background-position: top 40px left -100px;
    }
    .box-icon.ilog {
      background-position: top 40px left -150px;
    }
    .box-icon.iticket {
      background-position: top 40px left -200px;
    }
    background: ${(props) => props.theme.secondaryColor};
  }

  background: ${(props) => (props.active ? props.theme.secondaryColor : 'transparent')};

  .k-icon {
    color: ${(props) => props.theme.gray.shadeF};
  }
`;

export const SectionIcon = styled.div`
  background-image: url(${(props) => props.src});
  display: block;
  background-size: 50px;
  margin: 0 auto;
  width: ${(props) => props.theme.default?.desktop_menu_icon_width};
  ${(props) => dynamicStyles(props.theme.resolutions, 'desktop_menu_icon_width', 'width')};
  height: 34px;
  background-position: top 97px left -200px;
  &.active {
    background-position: top 47px left -200px;
  }

  display: flex;
`;

export const SectionLabel = styled.div`
  display: flex;
  text-align: center;
  font-size: ${(props) => props.theme.default?.desktop_menu_icon_font};
  ${(props) => dynamicStyles(props.theme.resolutions, 'desktop_menu_icon_font', 'font-size')};
`;

export const MainLinkIcon = styled.div`
  margin-right: 12px;
  width: 6px;
  height: 6px;
  margin-top: 14px;
  align-self: flex-start;
  border-radius: 6px;
  background: ${(props) => props.theme.gray.shadeF};
`;

export const MainLinkLabel = styled.div`
  display: flex;
  flex: 1;
  @media only screen and (max-width: ${deviceBreakpoints.mLaptop}px) {
    flex: none;
    margin-right: 10px;
  }
`;

export const MainLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  justify-content: space-between;
  width: ${(props) => props.theme.default?.desktop_menu_submenu_area_width};
  ${(props) => dynamicStyles(props.theme.resolutions, 'desktop_menu_submenu_area_width', 'width')};
  .main-link {
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.gray.shadeF};
    text-decoration: none;
    margin: 4px 0;
    font-size: ${(props) => props.theme.default?.desktop_menu_submenu_font};
    ${(props) => dynamicStyles(props.theme.resolutions, 'desktop_menu_submenu_font', 'font-size')};
    background: ${(props) => (props.active ? props.theme.secondaryLightColor : 'transparent')};
    border-radius: 8px;
    line-height: 34px;

    &:hover {
      ${MainLinkLabel} {
        text-decoration: underline;
      }
    }
  }
`;

export const Divider = styled.div`
  display: flex;
  height: 1px;
  background: ${(props) => props.theme.gray.shadeF};
  margin: 20px 0;
`;

export const UIDeatils = styled.div`
  .time {
    margin: 0;
    color: darkgray;
    margin-bottom: 4px;
  }
  .date {
    margin: 0;
    color: white;
  }
`;

export const AppDrawerMobileContainer = styled.div`
  // display: none;
  height: 100%;
  width: 100%;
  background: ${(props) => props.theme.appDrawer.mobile.backgroundColor};
  border-bottom: 1px solid ${(props) => props.theme.appDrawer.mobile.borderBottomColor};
  border-top: 1px solid ${(props) => props.theme.appDrawer.mobile.borderTopColor};
  opacity: 0.97;

  &::after {
    content: '';
    width: 100%;
    height: 1px;
    background: ${(props) => props.theme.appDrawer.mobile.borderTopColor};
  }

  @media only screen and (min-width: ${deviceBreakpoints.mLaptop}px) {
    display: none;
  }
`;

export const MobileSectionLinkContainer = styled(Link)`
  display: grid;
  max-height: ${(props) => (props.active ? (props.linkCounts + 1) * 60 : 45)}px;
  overflow: hidden;
  transition: max-height 500ms ease;
`;

export const MobileSectionLink = styled.div`
  display: flex;
  height: 45px;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  color: ${(props) => props.theme.gray.shadeF};
  cursor: pointer;
  font-size: ${(props) => props.theme.default?.desktop_menu_icon_font};
  ${(props) => dynamicStyles(props.theme.resolutions, 'desktop_menu_icon_font', 'font-size')};
  ${(props) => props.theme.appDrawer.mobile.borderBottomColor};
  border-top: 1px solid ${(props) => props.theme.appDrawer.mobile.borderTopColor};
  border-bottom: 1px solid ${(props) => props.theme.appDrawer.mobile.borderBottomColor};
  box-shadow: ${(props) => (props.active ? props.theme.appDrawer.mobile.section.activeBoxShadow : 'none')};

  i {
    font-size: 12px;
    line-height: 12px;
  }
`;

export const MobileLinksContainer = styled.div`
  display: grid;

  .main-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 25px;
    padding-right: 10px;
    font-size: ${(props) => props.theme.default?.desktop_menu_submenu_font};
    ${(props) => dynamicStyles(props.theme.resolutions, 'desktop_menu_submenu_font', 'font-size')};
    height: 45px;
    border-top: 1px solid ${(props) => props.theme.appDrawer.mobile.borderTopColor};
    border-bottom: 1px solid ${(props) => props.theme.appDrawer.mobile.borderBottomColor};
    background: ${(props) => props.theme.appDrawer.mobile.link.backgroundColor};
    color: ${(props) => props.theme.gray.shadeF};

    .badge-number {
      background: ${(props) => props.theme.appDrawer.mobile.link.badge.backgroundColor};
      color: ${(props) => props.theme.gray.shadeF};
    }
  }
`;

export const BlinkBackground = styled.div`
  animation: ${(props) => (props.isAnimation ? 'blinkingBackground 2s infinite' : '')};
  border-radius: 10px;
  @keyframes blinkingBackground {
    50% {
      background-color: ${(props) => props.theme.primaryDarkColor};
    }
  }
`;

export const UserStatusMain = styled.div`
  color: white;
  h6 {
    margin: 0;
  }
`;

export const UserStatusContainer = styled.div`
  margin: 10px 0;
`;

export const UserStatus = styled.div`
  display: flex;
  i {
    margin-top: 2.5px;
    color: #0fff50;
    font-size: 10px;
    margin-right: 10px;
  }
  .font {
    font-size: ${(props) => props.theme.default?.desktop_menu_submenu_font};
    ${(props) => dynamicStyles(props.theme.resolutions, 'desktop_menu_submenu_font', 'font-size')};
  }
`;
